module.exports = __webpack_public_path__ + "static/me-8e1b3765d62e15615d7e3fbcf557f91b.jpg";